import { render, staticRenderFns } from "./requestHeader.vue?vue&type=template&id=bab491ec&"
import script from "./requestHeader.vue?vue&type=script&lang=js&"
export * from "./requestHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports